import { calcWagerTax, getTaxConf } from "~/utils/betslip/taxes";

export const calculateActualWager = (wager: number, paymentType: 1 | 2 | 4) => {
	if (paymentType !== 1) return wager;
	const taxConfig = getTaxConf(paymentType);
	if (taxConfig && taxConfig.TaxType === "Wager") {
		const wagerTax = calcWagerTax(wager, paymentType, taxConfig);
		return wager - wagerTax;
	}
	return wager;
};
